// ヘッダーの幅を計算する関数
export function headerCalcWidth(isDrawerOpened: boolean, isMobile: boolean = false): number {
    if (isMobile) {
        // SP版はサイドバー非表示につき固定値
        return 20;
    }
    // PC版はサイドバーの幅 + padding 10px * 2(左右) で計算
    return isDrawerOpened ? 276 : 76;
}
